import { AlertTriangle } from 'lucide-react';
import { TH } from '../lib/theme';

export function RecallAlert({ alert, onAck, dm }) {
  const T = TH(dm);
  const { recall, match, lot, compoundLabel, noun } = alert;
  const lotList = (recall.lots || []).map(l => l.lot).join(', ');
  const message = match === 'lot'
    ? <>Your {compoundLabel} {noun} (lot <strong>{lot}</strong>) is on the recall list. Stop using it.</>
    : lot
      ? <>FDA&apos;s notice didn&apos;t include a readable lot list. Compare your lot <strong>{lot}</strong> against the notice.</>
      : <>Your {compoundLabel} {noun} has no lot # recorded. Check your label against the recalled lots{lotList ? <>: <strong>{lotList}</strong></> : ' in the notice'}.</>;
  return (
    <div data-testid="recall-alert" data-match={match} style={{ padding: '12px 14px', background: 'rgba(232,80,80,0.12)', border: '1px solid rgba(232,80,80,0.6)', borderRadius: 12, marginBottom: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 10, fontFamily: 'monospace', color: '#e84040', letterSpacing: '0.08em', fontWeight: '600', marginBottom: 4 }}>
        <AlertTriangle size={13} />RECALL · FDA{match === 'possible' ? ' · POSSIBLE MATCH' : ''}
      </div>
      <div style={{ fontSize: 13, color: T.TEXT, fontWeight: '600', marginBottom: 4 }}>{recall.firm} recalled {recall.product || compoundLabel}</div>
      <div data-testid="recall-alert-body" style={{ fontSize: 12, color: T.TEXT, lineHeight: 1.5, marginBottom: 6 }}>{message}</div>
      {recall.reason && <div style={{ fontSize: 11, color: T.DIM, marginBottom: 8 }}>Reason: {recall.reason}</div>}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <a data-testid="recall-alert-link" href={recall.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: T.CYAN }}>View FDA notice ↗</a>
        <button data-testid="recall-alert-ack" onClick={() => onAck(alert)} style={{ padding: '5px 12px', borderRadius: 20, cursor: 'pointer', fontSize: 11, fontFamily: 'monospace', fontWeight: '600', background: 'transparent', color: '#e84040', border: '1px solid rgba(232,80,80,0.5)' }}>I&apos;ve seen this</button>
      </div>
      <div style={{ fontSize: 10, color: T.DIM, marginTop: 8 }}>Contact your provider if you&apos;ve had a reaction. Not medical advice.</div>
    </div>
  );
}
